module.exports = __webpack_public_path__ + "img/dream4.39f452ea.png";